import {Bank} from 'domain/usecases/private/refund/request/get-beneficiary-bank-data';
import {makeRefundPutBank} from 'main/factories/usecases';

export async function putRefundBankData(bankData: Bank) {
	const payload = {
		account: bankData.account,
		accountDigit: bankData.accountDigit,
		agency: bankData.agency,
		bank: bankData.bank.code,
		agencyDigit: bankData.agencyDigit,
	};

	await makeRefundPutBank().put(payload);

	return bankData;
}
